import { render, staticRenderFns } from "./EditModelAsset.vue?vue&type=template&id=30517966&"
import script from "./EditModelAsset.vue?vue&type=script&lang=ts&"
export * from "./EditModelAsset.vue?vue&type=script&lang=ts&"
import style0 from "./EditModelAsset.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports